import { Outlet } from 'react-router';

import Header from '@/components/header';
import Footer from '@/components/footer';
import HeadTags from '@/components/headTags';

function SharedLayout() {
  return (
    <>
      <Header />
      <main>
        <HeadTags />
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default SharedLayout;
